/**
 * gotu-banner8-palco.js
 * Banner de Halloween "O Palco Encantado": troca de cena, videos e contagem.
 * GOTU 2026-09-15
 *
 * A CENA SO MUDA QUANDO O VIDEO ACABA.
 * Nada de temporizador a cortar por cima: os videos nao levam loop e a troca
 * esta amarrada ao evento 'ended'. Havia um temporizador fixo que cortava a
 * meio de uma segunda passagem — dava um salto feio de um segundo.
 *
 * O video seguinte comeca a carregar 2 s antes do fim do que esta em palco, e
 * arranca 300 ms antes da troca, para a passagem nao apanhar um fotograma preso.
 * Assim o peso continua a ser pago cena a cena, sem engasgo na transicao.
 */
(function () {
  'use strict';

  var FADE = 600;   // tem de bater certo com a transicao de .pe-scene no CSS
  var PRIME = 2.0;  // segundos antes do fim em que se comeca a carregar o seguinte
  var LEAD = 300;   // ms de avanco com que o video seguinte arranca

  function init() {
    var root = document.getElementById('pe-root');
    if (!root) return;

    var tabs   = root.querySelectorAll('.pe-act');
    var scenes = root.querySelectorAll('.pe-scene');
    var name   = document.getElementById('pe-act-name');
    var titles = [
      'Ato I: Diabinho, Bruxa Estrelada & Caldeirão',
      'Ato II: Bebé Abóbora, Palhaço Circo & Frankenstein',
      'Ato III: Bruxas Encantadas & Capa Teia de Aranha',
      'Ato IV: Menino Esqueleto, Fantasma & Aranha'
    ];
    var n = scenes.length;

    var i = 0, manual = false, visible = false, primed = -1, guard = null, leadDone = false;
    var slow = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function video(k) { return scenes[k] ? scenes[k].querySelector('video') : null; }

    function load(k) {
      var el = video(k);
      if (!el) return;
      if (el.getAttribute('preload') !== 'auto') {
        el.setAttribute('preload', 'auto');
        el.preload = 'auto';
        el.load();
      }
    }

    function start(k) {
      var el = video(k);
      if (!el) return;
      load(k);
      try { el.currentTime = 0; } catch (e) {}
      var p = el.play();
      if (p && p.catch) p.catch(function () {});
    }

    function stop(k) {
      var el = video(k);
      if (!el) return;
      el.pause();
      try { el.currentTime = 0; } catch (e) {}
    }

    function clearTimers() {
      if (guard) { clearTimeout(guard); guard = null; }
      leadDone = false;
    }

    // Rede de seguranca: se o 'ended' nunca chegar (ficheiro em falta, aba
    // suspensa, codec), a cena avanca na mesma um pouco depois da duracao.
    function armGuard() {
      if (guard) clearTimeout(guard);
      if (manual || !visible || slow) return;
      var el = video(i);
      var d = (el && el.duration && isFinite(el.duration)) ? el.duration : 5;
      guard = setTimeout(function () { next(); }, (d + 1.5) * 1000);
    }

    function next() { show((i + 1) % n, false); }

    function show(k, byUser) {
      if (byUser) { manual = true; }
      clearTimers();
      var prev = i;
      i = k;
      primed = -1;

      for (var t = 0; t < tabs.length; t++) {
        var on = (t === k);
        tabs[t].classList.toggle('is-active', on);
        tabs[t].setAttribute('aria-selected', on ? 'true' : 'false');
        if (scenes[t]) scenes[t].classList.toggle('is-active', on);
      }
      if (name && titles[k]) name.textContent = titles[k];

      if (visible) {
        start(k);
        if (prev !== k) {
          // so se pausa o anterior depois do fade, senao ve-se um salto
          setTimeout(function () { if (i !== prev) stop(prev); }, FADE);
        }
        armGuard();
      }
    }

    for (var t2 = 0; t2 < tabs.length; t2++) {
      (function (idx) {
        tabs[idx].addEventListener('click', function () { show(idx, true); });
      })(t2);
    }

    for (var v = 0; v < n; v++) {
      (function (idx) {
        var el = video(idx);
        if (!el) return;
        // iOS so arranca sem gesto se estiver mesmo tudo em silencio
        el.muted = true; el.defaultMuted = true;
        el.setAttribute('muted', '');
        el.setAttribute('playsinline', '');
        el.setAttribute('webkit-playsinline', '');
        el.removeAttribute('loop');
        el.loop = false;

        el.addEventListener('ended', function () {
          if (manual || !visible || i !== idx) return;
          next();
        });

        el.addEventListener('timeupdate', function () {
          if (i !== idx || manual || !el.duration || !isFinite(el.duration)) return;
          var left = el.duration - el.currentTime;
          var nx = (idx + 1) % n;
          if (left <= PRIME && primed !== nx) { primed = nx; load(nx); }
          if (left <= LEAD / 1000 && !leadDone) {
            leadDone = true;                        // arranca o seguinte um pouco antes
            var eln = video(nx);
            if (eln) {
              try { eln.currentTime = 0; } catch (e) {}
              var pn = eln.play();
              if (pn && pn.catch) pn.catch(function () {});
            }
          }
        });

        el.addEventListener('loadedmetadata', function () { if (i === idx) armGuard(); });
      })(v);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          visible = e.isIntersecting;
          if (visible) { start(i); armGuard(); }
          else { clearTimers(); stop(i); }
        });
      }, { threshold: 0.2 }).observe(root);
    } else {
      visible = true; start(0); armGuard();
    }

    // Contagem decrescente ate ao fecho da encomenda a marca.
    // Nunca em Liquid: a homepage e servida de cache e o numero ficaria preso.
    var deadline = new Date('2026-09-27T23:59:59+01:00').getTime();
    function pad(x) { return x < 10 ? '0' + x : String(x); }
    function set(id, val) { var el = document.getElementById(id); if (el) el.textContent = val; }
    function tick() {
      var diff = deadline - Date.now();
      if (diff < 0) diff = 0;
      set('pe-d', pad(Math.floor(diff / 86400000)));
      set('pe-h', pad(Math.floor(diff / 3600000) % 24));
      set('pe-m', pad(Math.floor(diff / 60000) % 60));
      set('pe-s', pad(Math.floor(diff / 1000) % 60));
    }
    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
